import { fileSizeConverter, FileSizeType, formatBytes, isNullOrUndefined } from '@bimser/core';
import * as React from 'react';
import BCCombobox, { IComboboxSelectedChangeEventArgs } from '../../../BCCombobox';
import BCInputNumber from '../../../BCInputNumber';
import ClassNames from '../../assets/style.scss';
import { IPropertyComponentProps, IPropertyItem } from '../../entities';

const InputNumberAddOnProperty = (props: IPropertyComponentProps) => {
	const [inputValue, setInputValue] = React.useState<number>(
		props.value ? formatBytes(props.value).value : null
	);
	const [comboboxValue, setComboboxValue] = React.useState<FileSizeType>(
		props.value
			? formatBytes(props.value).sizeType
			: props.item.externalData.addonAfterDefaultValue
	);

	const replaceValue = (item: IPropertyItem, newValue: any) => {
		if (props.value || !isNullOrUndefined(newValue)) {
			props.onValueChanged(item, newValue);
		}
	};

	const onChange = (value: any) => {
		props.customChangeEvent
			? props.customChangeEvent(value, props)
			: replaceValue(props.item, value);
	};

	const onInputNumberChange = (inputValue: any) => {
		setInputValue(inputValue);
		onChange(fileSizeConverter(inputValue, comboboxValue, FileSizeType.B));
	};

	const onComboboxChange = (args: IComboboxSelectedChangeEventArgs) => {
		if (inputValue) {
			setInputValue(
				fileSizeConverter(props.value, FileSizeType.B, args.data as FileSizeType)
			);
		}
		setComboboxValue(args.data as FileSizeType);
	};

	const onFormat = (value: any) =>
		props.item.externalData?.formatter ? props.item.externalData.formatter(value) : value;

	const onParser = (value: any) =>
		props.item.externalData?.parser ? props.item.externalData.parser(value) : value;

	return (
		<div className={ClassNames.InputNumberAddOnContainer}>
			<BCInputNumber
				id={props.item.key}
				value={
					inputValue === undefined || props.value === null
						? props.item.placeholder
						: (inputValue as any)
				}
				style={props.style}
				className={ClassNames.inputNumber}
				disabled={props.item.disabled || props.readonly}
				readOnly={props.item.readOnly}
				min={props.minValue}
				formatter={onFormat}
				parser={onParser}
				onChange={onInputNumberChange}
				size="small"
			/>
			<BCCombobox
				defaultValue={comboboxValue}
				options={props.item.externalData.addonAfterOptions}
				showSearch={false}
				className={ClassNames.comboBox}
				onSelectedChange={onComboboxChange}
				size="small"
				readonly={props.readonly}
			/>
		</div>
	);
};
export default InputNumberAddOnProperty;
